import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import NavBar from "../components/NavBar";
import { useStateValue } from "../context";
import routes from "../routes/routesCode";
import ProjectBreadcrumb from "../core/ProjectBreadcrumb";

const LoggedInLayout = ({ children }) => {
  const [{ user }] = useStateValue();
  const location = useLocation();
  const roles = user.user.roles || [];

  // Publishers (non-admin users) cannot access users and tags pages
  if (
    !roles.includes("ADMIN") &&
    (location.pathname === routes.users.path || location.pathname === routes.tags.path)
  ) {
    return <Navigate to={routes.projects.path} replace />;
  }

  return (
    <>
      <header className={"ay-header"}>
        <NavBar />
      </header>
      <ProjectBreadcrumb />
      <main className={"ay-main"}>{children}</main>
    </>
  );
};

export default LoggedInLayout;
